module.exports = __webpack_public_path__ + "img/SI.99fab1cc.svg";